// TODO: refactor jQuery --> ES
import {Carousel} from './Elements';

export default class AsyncSectionLoader {
	constructor(app) {
		this.app = app;
		const self = this;

		// load on page Start
		setTimeout(function () {
			$(".js-post-section").each(function () {
				self.loadSection.call(self, $(this));
			})
		}, 1000) // loading Delay
	}

	loadSection(section) {
		const self = this;
		if (!section.hasClass("js-loaded") && !!section.data("url")) {
			$.ajax({
				method: "POST",
				url: section.data("url"),
				data: section.data("params")
			}).done(function (data) {
				section.html(data);
				section.addClass("js-loaded").trigger("load");
				self.app.iconLoader.loadSvgs();
				self.app.cookieManager._handleConsent();
				self.app.elements.carousels.push(
					...[...section.get(0).querySelectorAll('.schulte-carousel')].map(node => new Carousel(node))
				);
				$.getScript("/static/js/filter_fr.js");
			})
		}
	}
}
